import React from 'react';
import moment from 'moment';
import './ScheduleModal.css';

const DateInput = ({ date }) => {
  return (
    <div className='flex-columns' style={{ marginTop: 16 }}>
      <div>
        <span className='create-schedule-label'>Date</span>
      </div>
      <div className='flex-rows create-schedule-date-input' style={{ marginTop: 8, width: 128 }}>
        <div className='flex-columns' style={{ justifyContent: 'center' }}>
          <i className='fa fa-calendar-alt create-schedule-icon' style={{ marginLeft: 8, color: '#B4B4C6' }} />
        </div>
        <div className='flex-columns' style={{ marginLeft: 16, justifyContent: 'center' }}>
          <span className='create-schedule-input-text'>{moment(date).format('MMM D')}</span>
        </div>
      </div>
    </div>
  );
};

export default DateInput;
